import { $, rect } from "@utils/dom";
import ResizeOrientation from "@utils/resize";
import Viewport from "@utils/viewport";

export const SELECTOR = "[data-site-footer]";

class SiteFooter {
  constructor(init = false) {
    this.initialized = false;
    this.el = null;

    this._onResize = this._onResize.bind(this);

    init ? this.init() : null;
  }

  get name() {
    return `SiteHeader`;
  }

  init() {
    this.initialized = true;
    this.el = $(SELECTOR);

    if( !this.el ) return;

    this.stickyEl = $('.site-footer__sticky', this.el);

    this._onResize();
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();

    this.initialized = false;
    this.el = null;
    this.stickyEl = null;
  }

  _bindEvents(){ ResizeOrientation.add(this._onResize); }
  _unbindEvents(){ ResizeOrientation.remove(this._onResize); }

  _onResize() {
    if( !this.el || !this.stickyEl ) return;
    this.el.style.setProperty('--sticky-height', `${rect(Viewport.width < 768 ? this.stickyEl : this.el).height}px`);
  }
}

export default SiteFooter;
